export default "/static/334da737f892b360c0f8a4994f29cfcf844caefd/frontend/86f37156fb08c0c498ede517163d9d77.svg";